import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { EstadoAdjunto } from '../_models/estado-adjunto';

@Injectable({
  providedIn: 'root'
})
export class EstadoAdjuntoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/estadosAdjuntos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as EstadoAdjunto[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as EstadoAdjunto[] ) );
  }

  obtenerPorEstado( idEstado: string ) {
    return this.httClient.get( this.rutServicio + '/estado/' + idEstado ).pipe( map( res => res as EstadoAdjunto ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as EstadoAdjunto ) );
  }

  crear( regCrear: EstadoAdjunto ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as EstadoAdjunto ) );
  }

  actualizar( regActualizar: EstadoAdjunto ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as EstadoAdjunto ) );
  }

}
